export { default as PrevIcon } from '~icons/ic/outline-navigate-before';
